/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import clsx from 'clsx';

import { IconCollectionProps, IconCollectionVariation, IconCollectionAlignment } from './IconCollection.types';
import { StyledIconCollection } from './IconCollection.styles';
import { Icon } from '../../atoms/Icon';

export const IconCollection: React.FC<IconCollectionProps> = ({
  variation = 'logoLinks',
  id,
  iconCollectionData,
  alignment = 'vertical',
  iconClassName,
  iconSize,
  enableLinkClsName = false,
  forwardedRefs,
}) => {
  return (
    <StyledIconCollection
      data-component-name="m-ui-library-IconCollection"
      data-testid="ui-library-IconCollection"
      id={id}
      className={clsx(
        variation === IconCollectionVariation.LogoLinks && 'linkCollectionItem p-0',
        alignment === IconCollectionAlignment.Horizontal ? 'horizontal-align' : 'vertical-align'
      )}
    >
      {iconCollectionData?.length &&
        iconCollectionData?.map((el: any, idx: number) => (
          <li
            className={clsx({
              linkItems: variation === IconCollectionVariation.LogoLinks,
              'mr-2': !enableLinkClsName,
            })}
            key={`${el}_${idx}`}
            id={el?.id}
          >
            <Icon
              iconClass={clsx(
                iconClassName,
                el?.brandtag?.includes('portfolio') ? el.brandtag : `brand-logo-${el.brandtag}`,
                iconSize ? `icon-${iconSize}` : ''
              )}
              iconHref={el?.linkurl}
              rel={el?.openinanewtab ? 'noopener noreferrer' : ''}
              target={el?.openinanewtab ? '_blank' : '_self'}
              enableLinkClsName={enableLinkClsName}
              ref={forwardedRefs?.[idx]}
            >
              <span className="sr-only">{el?.linkText}</span>
              {el?.openinanewtab ? <span className="sr-only">Opens a new window</span> : ''}
            </Icon>
          </li>
        ))}
    </StyledIconCollection>
  );
};
